<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3><i class="fas fa-map-marked-alt"></i> Módulo de Visitas</h3>
          <small>Acompanhe, planeje e registre suas visitas.</small>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12 text-center">
          <b-card-group deck>
            <b-card
              class="text-center pb-2 mb-2 pointer"
              style="min-width: 10rem"
              @click.prevent="goTo('MinhasVisitas')"
            >
              <i
                class="fas fa-calendar-alt pt-4 text-third"
                style="font-size: 80px"
              />
              <h4 class="pt-3">Meus agendamentos</h4>
            </b-card>
            <b-card
              v-if="!isMoving"
              class="text-center pb-2 mb-2 pointer"
              style="min-width: 10rem"
              @click.prevent="goTo('DeslocamentoPontoInicial')"
            >
              <i
                class="fas fa-map-marker-alt pt-4 text-third"
                style="font-size: 80px"
              />
              <h4 class="pt-3">Iniciar deslocamento</h4>
            </b-card>
            <b-card
              v-if="isMoving && !hasCheckIn"
              class="text-center pb-2 mb-2 pointer"
              style="min-width: 10rem"
              @click.prevent="goTo('DeslocamentoPontoFinal')"
            >
              <i
                class="fas fa-map-marker pt-4 text-third"
                style="font-size: 80px"
              />
              <h4 class="pt-3">Finalizar deslocamento</h4>
            </b-card>
            <b-card
              v-if="isMoving && !hasCheckIn"
              class="text-center pb-2 mb-2 pointer"
              style="min-width: 10rem"
              @click.prevent="goTo('DeslocamentoCheckin')"
            >
              <i
                class="fas fa-store-alt pt-4 text-third"
                style="font-size: 80px"
              />
              <h4 class="pt-3">Check-in</h4>
            </b-card>
            <b-card
              v-if="isMoving && hasCheckIn"
              class="text-center pb-2 mb-2 pointer"
              style="min-width: 10rem"
              @click.prevent="goTo('FollowUp')"
            >
              <i
                class="fas fa-address-card pt-4 text-third"
                style="font-size: 80px"
              />
              <h4 class="pt-3">Oportunidades</h4>
            </b-card>
            <b-card
              v-if="isMoving && hasCheckIn"
              class="text-center pb-2 mb-2 pointer"
              style="min-width: 10rem"
              @click.prevent="showCheckoutModal"
            >
              <i
                class="fas fa-road pt-4 text-third"
                style="font-size: 80px"
              />
              <h4 class="pt-3">Check-out</h4>
            </b-card>
          </b-card-group>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img
            src="/static/img/bg/world_re_768g.svg"
            style="width: 40%; opacity: 0.2"
          />
        </div>
      </div>
    </div>

    <CheckOutModal ref="CheckOutModal" />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'

import CheckOutModal from './deslocamento/register/modal/checkout.vue'

export default {
  name: 'Visitas',
  data () {
    return {
      isMoving: false,
      travel: null,
      hasCheckIn: false
    }
  },
  components: {
    CheckOutModal
  },
  async mounted () {
    Tools.MinimizedSidebar()
    const resp = await DeslocamentoRepository.GetActive()
    this.travel = resp.data
    this.isMoving = this.travel !== ''
    this.hasCheckIn =
      this.isMoving &&
      this.travel.visitas.length &&
      this.travel.visitas.filter((v) => v.dataCheckOut === null).length !== 0
  },
  methods: {
    goTo (path) {
      this.$router.push({ name: path })
    },
    showCheckoutModal () {
      this.$refs.CheckOutModal.showModal()
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.25rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/visitas.vue